import moment from 'moment';
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import ReactDatePicker from 'react-datepicker';
import { AiOutlineCalendar } from 'react-icons/ai';
import { FiUpload } from 'react-icons/fi';
import { IoMdArrowDropleft, IoMdArrowDropright } from "react-icons/io";
import useMultipleImgUpload from '../../../hooks/useMultipleImgUpload';
import GallaryBox from '../GallaryBox';
import Loader from '../Loader';




const allMonths = [
  
    {id:1, name:"January"},
    {id:2, name:"February"},
    {id:3, name:"March"},
    {id:4, name:"April"},
    {id:5, name:"May"},
    {id:6, name:"June"},
    {id:7, name:"July"},
    {id:8, name:"August"},
    {id:9, name:"September"},
    {id:10, name:"October"},
    {id:11, name:"November"},
    {id:12, name:"December"},
  ];



const PaymentModal = ({show,handleClose,loading,tenantdetails}) => {
    const {
        onSelectFile,
        deleteHandler,
        uploadToserver,
        selectedImages,
        setSelectedImages,
        defaultImg,
        setdefaultImg,
        handleDefaultImage,
        ImgLinks,
        setImgLinks,
      } = useMultipleImgUpload();
     
      const [startDate, setStartDate] = useState(new Date());

  
const slipDownload=()=>{

}
  
  return (
    <>
 

  
    <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        className="Raise-rq-modal-popup payment-tenant"
      >
        <Modal.Header closeButton>
          <Modal.Title>
         

            <div className="border d-flex p-2 rounded-3 align-items-center">
                <div className="d-flex align-items-center">

              <button onClick={()=>setStartDate(new Date(startDate.setDate(startDate.getDate() - 30)))}>  <IoMdArrowDropleft/></button>
                <span className='mx-1'>{moment(startDate).format('MMMM')}</span>
              <button  onClick={()=>setStartDate(new Date(startDate.setDate(startDate.getDate() + 30)))}>  <IoMdArrowDropright/></button>
                </div>
                <div className="d-flex align-items-center">

              <button onClick={()=>setStartDate(new Date(startDate.setDate(startDate.getDate() - 365)))}>  <IoMdArrowDropleft/></button>
                <span  className='mx-1'>{moment(startDate).format('YYYY')}</span>
              <button onClick={()=>setStartDate(new Date(startDate.setDate(startDate.getDate() + 365)))}>  <IoMdArrowDropright/></button>
                {/* <label htmlFor="statementDate">
                <AiOutlineCalendar/>

                </label> */}


     
             
                </div>
                <ReactDatePicker
        id="datepicker"
        selected={startDate}
        className='mx-2'
        onChange={(date) => setStartDate(date)}
        dateFormat="yyyy-MM-dd"
        showPopperArrow={false}
        customInput={<AiOutlineCalendar/>}
      />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {true ? (
            <form action="" className="add-form add-building-area row">
              {loading ? (
                <Loader />
              ) : (
                <>
                  <div className="col-lg-8">
                 <div className="row">
                 <section className="view-tenant-main row d-flex justfy-content-between  mb-4">
      
          <div className="">
          <ul className="d-flex flex-wrap mt-4">
            <li className='pe-5'>
              <span>Taxes :</span>
              <p>2000</p>
            </li>
            <li className='pe-5'>
              <span>Locker :</span>
              <p>Yes</p>
            </li>
            <li className='pe-5'>
              <span>Internet :</span>
              <p>Yes</p>
            </li>
            <li className='pe-5'>
              <span>Payment Mode :</span>
              <p>Cash</p>
            </li>
            <li className='pe-5'>
              <span>Parking & Other :</span>
              <p>Yes</p>
            </li>

           

           
          </ul>
          <ul className="d-flex flex-wrap mt-4">
            <li className='pe-5'>
              <span>Key Deposit :</span>
              <p>500</p>
            </li>
            <li className='pe-5'>
              <span>Laundry Card Deposit :</span>
              <p>Yes</p>
            </li>
            <li className='pe-5'>
              <span>Advance Rent :</span>
              <p>5000</p>
            </li>

           

           
          </ul>
          </div>

          <hr />
          <p className='text-info'>Month Of {moment(startDate).format('MMMM')}</p>
          <hr />
          <div className="">
          <ul className="d-flex flex-wrap mt-4">
            <li className='pe-5  border-end'>
              <span>NSF :</span>
              <p>2000</p>
            </li>
            <li className='  border-end px-3'>
              <span>Write Off & Adj:</span>
              <p>2000</p>
            </li>
            <li className='  border-end px-3'>
              <span>Hydro Inv:</span>
              <p>2000</p>
            </li>
            <li className='  border-end px-3'>
              <span>Outstanding Previus Month :</span>
              <p>50</p>
            </li>
            <li className='  px-3'>
              <span>Total outstanding :</span>
              <p>550</p>
            </li>

            <ul className="d-flex flex-wrap my-4 ">
            <li className='border-end  pe-3'>
              <span>Collected Amount:</span>
              <p>200</p>
            </li>
            <li className='  px-3'>
              <span>Outstanding this month :</span>
              <p>550</p>
            </li>
            </ul>

           

           
          </ul>
        
          </div>
          <hr />
          <div className="">
          <ul className="d-flex flex-wrap mt-4">
            <li className='pe-5'>
              <span>Payment Mode:</span>
             <p>Cash</p>
            </li>
            <li className='pe-5'>
              <span>Receipt No:</span>
             <p>RC001</p>
            </li>
            <li className='pe-5'>
              <span>Cash/CHQ/Bank:</span>
             <p>TB Bank XXXX0</p>
            </li>
            <li className='pe-5'>
              <span>Send renewal or Not:</span>
             <p>XXXXX</p>
            </li>

           

           
          </ul>
     <hr/>
          </div>
         
      

      </section>
                 </div>
                  </div>
                  <GallaryBox   selectedImages={selectedImages}  defaultImg={defaultImg} handleDefaultImage={handleDefaultImage} onSelectFile={onSelectFile} deleteHandler={deleteHandler}/>

                  <div className="d-flex justify-content-end align-items-center ">
           
           
             <button className='d-flex' type='button' onClick={()=>slipDownload}> 
                <span>Download Payment receipt</span>
                <FiUpload className="ms-2 ms-lg-3 upload-icon" />
           </button>
 
          </div>
                  <div className="w-100">
                    <div className="d-flex mt-md-5">
                      {/* <button
                    className="skip-btn"
                    onClick={() => {
                      setShow(false);
                    }}
                  >
                    Cancel
                  </button> */}
                      <button
                        className="btn btn-primary"
                        // onClick={(e) => {
                        //   TaskFunc(e);
                        // }}
                      >
                       Submit
                      </button>
                    </div>
                  </div>
                </>
              )}
            </form>
          ) : (
            <p className="text-center text-danger">Please active the Tenant</p>
          )}
        </Modal.Body>
      </Modal>
  </>
  )
}

export default PaymentModal